import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import ChoosenItem from "./ChoosenItem";
import LoaderCustom from "utils/LoaderCustom";

import karbala from "../../assets/images/New folder/bargozide ha/Rajebe Karbala pic.png";
import madar from "../../assets/images/New folder/bargozide ha/hazrat madar.png";
import asir from "../../assets/images/New folder/bargozide ha/asire entezar pic.png";
import chador from "../../assets/images/New folder/bargozide ha/nakhe chador pic.png";

import { useEffect, useState } from "react";
import sendRequest from "hooks/useAxios";

function NewTabs({
  setShowAudioPlayer,
  setShowPlayerModal,
  tabTitle,
  setSelectedAlbum,
  setAboutTrackModal,
  setAddTrackModal,
  trackLists,
  selectedPlayList,
  setSelectedTrack
}) {
  let temp = [
    {
      name: "رمضان",
      key: "0",
      content: [{ name: "حضرت مادر", src: madar }],
    },
    {
      name: "فاطمیه",
      key: "7",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تگ آهنگ",
      key: "8",
      content: [
        { name: "حضرت مادر", src: madar },

        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "البوم تست",
      key: "9",
      content: [{ name: "نخ چادر", src: chador }],
    },
    {
      name: " عنوان طولانی",
      key: "22",
      content: [
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "البوم تست طولانی محرم",
      key: "21",
      content: [{ name: "راجع به کربلا", src: karbala }],
    },
    {
      name: "تست1",
      key: "1",
      content: [{ name: "اسیر انتظار", src: asir }],
    },
    {
      name: "تست2",
      key: "2",
      content: [
        { name: "اسیر انتظار", src: asir },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست3",
      key: "3",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
      ],
    },
    {
      name: "تست4",
      key: "4",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست5",
      key: "5",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست6",
      key: "6",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست7",
      key: "18",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست8",
      key: "19",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست9",
      key: "20",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست10",
      key: "10",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست11",
      key: "11",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست12",
      key: "12",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست13",
      key: "13",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست14",
      key: "14",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست15",
      key: "15",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست16",
      key: "16",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
    {
      name: "تست17",
      key: "17",
      content: [
        { name: "حضرت مادر", src: madar },
        { name: "اسیر انتظار", src: asir },
        { name: "راجع به کربلا", src: karbala },
        { name: "نخ چادر", src: chador },
      ],
    },
  ];
  const [tabData, setTabData] = useState([]);
  const [defaultTag, setDefaultTag] = useState(2);
  const [selectedTag, setSelectedTag] = useState(2);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    sendRequest("audio/search", {
      tags: selectedTag,
    }).then((res) => {
      setTabData(res.data.resTitle);
      setIsLoading(false);
    });
  }, [selectedTag]);
  return (
    <Tab.Container id="new-tab-ids" defaultActiveKey={defaultTag}>
      <Row>
        <Nav variant="pills" className="">
          <div
            className="d-flex w-100 scroll-style"
            style={{ overflowX: "auto", flexWrap: "nowrap" }}
          >
            {tabTitle.map((value) => (
              <Nav.Item
                onClick={() => {
                  setSelectedTag(value.id);
                }}
              >
                <Nav.Link eventKey={value.id}>
                  <div className="d-flex contain">
                    <div className="ps-2 tab-style">{value.title}</div>
                    <div className="tri" />
                  </div>
                </Nav.Link>
              </Nav.Item>
            ))}
          </div>

          <div className="d-flex w-100">
            <div
              style={{ backgroundColor: " #fe0000", height: 4 }}
              className="w-100"
            />
            <div
              style={{
                width: 5,
                height: 4,
                // backgroundImage: `linear-gradient(to bottom right, transparent 50%, red 0)`,
                // // backgroundSize: "50% 100%",
                // backgroundRepeat: "no-repeat",
                // backgroundPosition: "left, right",
              }}
            />
          </div>
        </Nav>

        <Tab.Content>
          {tabTitle?.map((value) => {
            return (
              <Tab.Pane eventKey={value.id}>
                {isLoading ? (
                  <div className="position-relative" style={{ minHeight: 150 }}>
                    <LoaderCustom />
                  </div>
                ) : (
                  <div className="d-flex flex-wrap">
                    {tabData.length > 0 ? (
                      tabData?.map((val) => {
                        return (
                          <div className="col-xl-3 col-lg-4 col-sm-6 col-12">
                            <ChoosenItem
                              value={val}
                              src={val?.audio_file?.path}
                              title={val?.title}
                              setShowAudioPlayer={setShowAudioPlayer}
                              setShowPlayerModal={setShowPlayerModal}
                              setSelectedAlbum={setSelectedAlbum}
                              setAddTrackModal={setAddTrackModal}
                              setAboutTrackModal={setAboutTrackModal}
                              trackLists={tabData}
                              selectedPlayList={selectedPlayList}
                              setSelectedTrack={setSelectedTrack}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center m-3 text-light flex-grow-1">
                        در حال حاضر ترکی وجود ندارد.
                      </div>
                    )}
                  </div>
                )}
              </Tab.Pane>
            );
          })}
        </Tab.Content>
      </Row>
    </Tab.Container>
  );
}

export default NewTabs;
